import { render, staticRenderFns } from "./CableTv.vue?vue&type=template&id=63ce9c0d&scoped=true"
import script from "./CableTv.vue?vue&type=script&lang=js"
export * from "./CableTv.vue?vue&type=script&lang=js"
import style0 from "./CableTv.vue?vue&type=style&index=0&id=63ce9c0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ce9c0d",
  null
  
)

export default component.exports